import React from 'react'
import PropTypes from 'prop-types'
import MuiCheckBox from '@material-ui/core/Checkbox'

const CheckBox = props => {
  const { children, checked, color, onChange, disabled, ...otherProps } = props
  const handleOnChange = React.useCallback((e) => onChange(e.target.checked), [onChange])

  return <MuiCheckBox
    color={color}
    checked={checked}
    disabled={disabled}
    onChange={handleOnChange}
    {...otherProps}>{children}</MuiCheckBox>
}

CheckBox.propTypes = {
  color: PropTypes.oneOf(['primary', 'secondary', 'default']),
  checked: PropTypes.bool,
  onChange: PropTypes.func,
  disabled: PropTypes.bool
}
CheckBox.defaultProps = {
  color: 'primary',
  disabled: false
}

export default CheckBox
